import React from 'react';
import { useTranslation } from 'react-i18next';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';

import { CalendarDayBadge } from './CalendarDayBadge';

export function NewCalendarSidebar({
  adapterLocale,
  badgeDays,
  badgeLoading,
  categories,
  catChecks,
  localeText,
  onCategoryCheckChange,
  onCreateTask,
  onDateChange,
  onDateDoubleClick,
  onMonthChange,
  onlyWithHacs,
  selectedDate,
  setOnlyWithHacs,
  setShowSystemTasks,
  showSystemTasks,
}) {
  const { t } = useTranslation();

  return (
    <aside>
      <div className="actions">
        <button type="button" className="btn primary fit small" onClick={onCreateTask}>
          {t('calendar-new-reminder')}
        </button>
      </div>

      <div>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale} localeText={localeText}>
          <DateCalendar
            value={selectedDate}
            onChange={onDateChange}
            onMonthChange={onMonthChange}
            loading={badgeLoading}
            slots={{ day: CalendarDayBadge }}
            slotProps={{ day: { highlightedDays: badgeDays, onDayDoubleClick: onDateDoubleClick, selectedDate } }}
          />
        </LocalizationProvider>
      </div>

      <div className="filters">
        <div>
          <strong>{t('calendar-filter-1')}</strong>
          <FormGroup>
            <FormControlLabel
              control={<Checkbox checked={showSystemTasks} onChange={(e) => setShowSystemTasks(e.target.checked)} />}
              label={t('calendar-filter-system-reminders', { defaultValue: 'Automatic reminders' })}
            />
            <FormControlLabel
              control={<Checkbox checked={onlyWithHacs} onChange={(e) => setOnlyWithHacs(e.target.checked)} />}
              label={t('calendar-filter-1-a')}
            />
          </FormGroup>
        </div>

        <div>
          <strong>{t('calendar-filter-2')}</strong>
          <FormGroup>
            {categories.map((category) => (
              <FormControlLabel
                key={String(category.id)}
                className={'cat-' + category.id}
                control={
                  <Checkbox
                    checked={Boolean(catChecks?.[category.id])}
                    onChange={(e) => onCategoryCheckChange(category.id, e.target.checked)}
                  />
                }
                label={category.label}
              />
            ))}
          </FormGroup>
        </div>
      </div>
    </aside>
  );
}
